export default {
  props: {
    options: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  inject: ['parent'],
  methods: {
    done() {
      if (this.parent) {
        this.parent.doClose();
      } else if (this.$parent && this.$parent.$parent) {
        this.$parent.$parent.doClose();
      }
    },
    cancel() {
      this.$emit('close');
    },
    confirmForm(formName = 'form') {
      this.done();
    }
  }
};
